


























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AppFormToolBar extends Vue {
  @Prop() title!: string
  @Prop({ default: true }) initial: boolean
  protected expand = true

  created () {
    this.expand = this.initial
  }

  get activityURL () {
    return `/live/recruit/${this.$router.currentRoute.params.recruitAccountOid}`
  }

  toggle () {
    this.expand = !this.expand
    this.$emit('toggle', this.expand)
  }
}
